import { Accordion } from '@ferreri/prever-component-lib';
import { DependentCardList } from './DependentCardList';
import { KinshipGroupType } from './rules.types';

type AccordionItemProps = {
  allGroups: KinshipGroupType[];
};

export const AccordionItem = (props: AccordionItemProps) => {
  return (
    <Accordion
      items={props.allGroups?.map((kinshipGroup: KinshipGroupType) => ({
        title: kinshipGroup.kinship?.name,
        content: (
          <DependentCardList
            groups={kinshipGroup?.groups}
            kinship={kinshipGroup.kinship}
            maxQuantityAdditional={kinshipGroup.maxQuantityAdditional}
            hasAdditionalDependentGlobal={
              kinshipGroup.hasAdditionalDependentGlobal
            }
          />
        ),
      }))}
    />
  );
};
